import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, postObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Activity/${id}`;
	return axios.put(url, postObject).toOptionalVoid();
}

export interface Request {
	sortOrder: number;
	nameTranslations: {
		[key: string]: string;
	};
}
